import { styled, Typography } from '@mui/material'

export const StyledList = styled(Typography)(({ theme }) => ({
  ul: {
    listStyle: 'none',
    margin: 0,
    padding: 0,

    li: {
      position: 'relative',
      marginBottom: theme.spacing(0),
      paddingLeft: theme.spacing(1.4),

      '&:last-of-type': {
        marginBottom: 0,
      },

	  '&::before': {
	  content: '""',
	  position: 'absolute',
	  top: '.6em',     
	  left: 0,
	  width: '8px',
	  height: '2px',
	  backgroundColor: '#B85967',
	},
    },
  },
}))

/*
Refectored this because :marker is only supported in Chrome.
import { styled, Typography } from '@mui/material'

export const StyledList = styled(Typography)(({ theme }) => ({
  ul: {
    li: {
      paddingLeft: theme.spacing(0.5),
      span: {},
      '&::marker': {
        content: '"-"',
      },
    },
  },
  li: {
    marginBottom: theme.spacing(1),
    '&:last-of-type': {
      marginBottom: 0
    }
  }
	
 	
}))
*/